function area (points, signed) {
    let l = points.length
    let det = 0
    let isSigned = signed || false

    points = points.map(normalize)
    if (points[0] != points[points.length -1])
        points = points.concat(points[0])

    for (let i = 0; i < l; i++)
        det += points[i].x * points[i + 1].y
            - points[i].y * points[i + 1].x
    if (isSigned)
        return det / 2
    else
        return Math.abs(det) / 2
}

function getCenter(polyPointArray) {
  const polyArray = polyPointArray.map((point) => [point.x, point.y]);
  let maxX = 0;
  let minX = Infinity;
  let maxY = 0;
  let minY = Infinity;
  polyArray.map(point => {
    const [x, y] = point;
    maxX = Math.max(maxX, x);
    minX = Math.min(minX, x);
    maxY = Math.max(maxY, y);
    minY = Math.min(minY, y);
  });
  const midX = minX + (maxX - minX) / 2;
  const midY = minY + (maxY - minY) / 2;
  return { x: midX, y: midY };
};

function normalize(point) {
    if (Array.isArray(point))
        return {
            x: point[0],
            y: point[1]
        }
    else
        return point
}

export { area, getCenter };